import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { type LoadingStateMode } from './loading-state.models';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatProgressSpinnerModule],
  selector: 'app-loading-state',
  styleUrl: './loading-state.scss',
  templateUrl: './loading-state.html',
})
export class LoadingState {
  readonly visible = input(true);
  readonly mode = input<LoadingStateMode>('inline');
  readonly label = input('Cargando…');
}
